var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.list,"item-key":"id","disable-pagination":false,"hide-default-footer":false,"fixed-header":true,"search":_vm.search},on:{"click:row":_vm.articleSelected},scopedSlots:_vm._u([{key:"item.id",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColor(item.is_published)}},[_vm._v(_vm._s(item.id))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }